import { RawKey } from '@master/annotation/RawKey'
import { Meta } from '@master/model/common/Meta'
import { Ignore } from '@master/annotation/Ignore'

export const header = [
  '_oid',
  'company_details_name',
  'company_short_name',
  'company_details_code',
  'company_details_effective_date',
  'company_details_status',
  'company_details_remarks'
]

export class CompanyDetailsMeta extends Meta {
  @RawKey('_oid')
  oid = ''

  companyDetailsName = ''
  companyShortName = ''
  companyDetailsCode = ''
  companyDetailsEffectiveDate: number | string = ''
  companyDetailsStatus = ''
  companyDetailsRemarks = ''

  @Ignore()
  emit = true
}
